/** Chip colours per Visit outcome, shared by the portal visit history and the schedule. */
export const visitStatusStyles: Record<string, string> = {
  Attended: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300",
  AttendedComp: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300",
  CancelledCharged: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300",
  CancelledWaived: "bg-grey-95 text-grey-40 dark:bg-primary-10 dark:text-grey-80",
};

/** The chip colour for an outcome the map doesn't know. */
export const fallbackVisitStatusStyle = "bg-grey-95 text-grey-40 dark:bg-primary-10 dark:text-grey-80";
